import { GetSharedCandidatesRosterDataOutput } from '$store/modules/candidates';

const SPKPanelHiddenSkill = ({
  hiddenSkills,
  showHiddenSkills,
  setShowHiddenSkills,
}: {
  hiddenSkills: GetSharedCandidatesRosterDataOutput['candidates'][number]['CandidateSkills'];
  showHiddenSkills: boolean;
  setShowHiddenSkills: (callback: (prev: boolean) => boolean) => void;
}) => {
  if (!showHiddenSkills) return null;
  return (
    <>
      {hiddenSkills?.map((singleSkill) => (
        <div
          className={`p-1 text-xs border border-gray-300 text-black/60 rounded text-nowrap ${
            showHiddenSkills ? 'flex' : ''
          }`}
          key={`hiddenSkill_${singleSkill.Id}`}
        >
          {singleSkill.Skill.title}
        </div>
      ))}
      <button
        className={`text-xs border border-spk-brightBlue text-spk-brightBlue p-1 rounded-full border-solid ${
          showHiddenSkills ? 'flex' : 'hidden'
        }`}
        type="button"
        onClick={() => setShowHiddenSkills((prev) => !prev)}
      >
        Show Less
      </button>
    </>
  );
};

export default SPKPanelHiddenSkill;
